import { useStore } from '@moonpig/web-core-stores'
import React, { FC } from 'react'
import { getDepartmentTitle } from '@moonpig/web-core-utils'
import type { SearchContext } from '../../store/slices/shared'
import { capitaliseFirstCharacter } from '../../utils'
import { getSearchTerm } from './getSearchTerm'

const getNlDepartment = (department: string) => {
  switch (department.toLowerCase()) {
    case 'gifts':
      return 'Cadeaus'
    case 'flowers':
      return 'Bloemen'
    case 'cards':
    default:
      return 'Kaarten'
  }
}

export const SearchTermHeaderText: FC<{
  totalCount: number
  searchContext: SearchContext
}> = ({ totalCount, searchContext }) => {
  const { store } = useStore()
  const isGreetz = store.id === 'nl'

  const { selectedSuggestion, searchTerm, correctedSearchTerm, departments } =
    searchContext

  const { term, isSearchTermBlank } = getSearchTerm({
    selectedSuggestion,
    searchTerm,
    correctedSearchTerm,
  })

  const departmentName = capitaliseFirstCharacter(
    getDepartmentTitle(departments[0]),
  )

  const searchTermHeader = isGreetz ? (
    <>
      <span>
        <strong>{totalCount} resultaten</strong> zichtbaar voor &quot;
      </span>
      <strong data-testid="department-headers-search-term">{term}</strong>
      <span>
        &quot; in <strong>{getNlDepartment(departmentName)}</strong>.
      </span>
    </>
  ) : (
    <>
      <span>
        Showing <strong>{totalCount} results</strong> for &quot;
      </span>
      <strong data-testid="department-headers-search-term">{term}</strong>
      <span>
        &quot; in <strong>{departmentName}</strong>.
      </span>
    </>
  )

  const blankSearchTermHeader = isGreetz ? (
    <span>
      <strong>{totalCount} resultaten</strong> zichtbaar voor &quot;
      <strong>{term}</strong>&quot; in{' '}
      <strong>{getNlDepartment(departmentName)}</strong>.
    </span>
  ) : (
    <span>
      Showing <strong>{totalCount} results</strong> in{' '}
      <strong>{departmentName}</strong>.
    </span>
  )

  return isSearchTermBlank ? blankSearchTermHeader : searchTermHeader
}
